import { render, staticRenderFns } from "./wangnianduibi.vue?vue&type=template&id=6b457b8c"
import script from "./wangnianduibi.vue?vue&type=script&lang=js"
export * from "./wangnianduibi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports